<template>
  <div
    class="top-0 left-0 right-0 w-full px-5 md:px-24 h-36 flex items-center justify-between mix-blend-difference fixed z-[9999]"
  >
    <div class="overflow-hidden">
      <img
        ref="navLogo"
        src="../assets/imgs/blackout-logo.svg"
        class="nav-logo transition-transform duration-1000"
        alt="blackout logo"
      />
    </div>
    <div class="hidden gap-12 items-center md:flex">
      <div class="nav-bar flex gap-7 items-center" ref="navBar">
        <a
          href="#new"
          class="font-primary text-white uppercase px-5 py-1 rounded-3xl duration-300 transition-all scroll-link"
          :class="{ active: activeSection === 'new' }"
          >New</a
        >
        <a
          href="#about"
          class="font-primary text-white px-5 py-1 rounded-3xl duration-300 transition-all uppercase scroll-link"
          :class="{ active: activeSection === 'about' }"
          >About</a
        >
        <a
          href="#contact"
          class="font-primary text-white px-5 py-1 rounded-3xl duration-300 transition-all uppercase scroll-link"
          :class="{ active: activeSection === 'contact' }"
          >Contact</a
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, onBeforeUnmount } from "vue";

const activeSection = ref("");
const navLogo = ref(null);
const navBar = ref(null);
const sectionIds = ["new", "about", "contact"];

const handleScroll = () => {
  let currentSection = "";
  const scrollPosition = window.scrollY + window.innerHeight / 2; // Center of the screen
  const triggerOffset = 200; // Adjust this value to control how far down into a section we need to scroll

  sectionIds.forEach((id) => {
    const section = document.getElementById(id);
    if (!section) return;

    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;

    if (
      scrollPosition >= sectionTop + triggerOffset &&
      scrollPosition < sectionTop + sectionHeight
    ) {
      currentSection = id;
    }
  });

  if (currentSection === "") {
    const scrollTop = window.scrollY;
    if (scrollTop < document.getElementById(sectionIds[0]).offsetTop) {
      currentSection = sectionIds[0];
    } else {
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionIds[i]);
        if (section && scrollTop >= section.offsetTop) {
          currentSection = sectionIds[i];
          break;
        }
      }
    }
  }

  activeSection.value = currentSection;
};

onMounted(() => {
  const links = document.querySelectorAll(".scroll-link");

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });

  window.addEventListener("scroll", handleScroll);

  // Call handleScroll to set the initial active section based on current scroll position
  handleScroll();

  nextTick(() => {
    setTimeout(() => {
      if (navLogo.value) {
        navLogo.value.classList.add("translate-down");
      }
      if (navBar.value) {
        navBar.value.classList.add("make-navbar-visible");
      }
    }, 2000);
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
.nav-logo {
  transform: translateY(-100%);
  transition-duration: 2000ms;
}
.nav-bar {
  opacity: 0;
}
.nav-bar.make-navbar-visible {
  opacity: 1;
  transition: opacity 2s;
}
.nav-logo.translate-down {
  transform: translateY(0);
  transition-timing-function: cubic-bezier(.4,.17,.36,.87);
}
.nav-bar .active {
  outline: 1px solid white; /* Adjust the outline style as needed */
}
</style>
